import React from 'react'
import { Link } from 'react-router-dom'
import { TextContainer, Image, DisplayText, Markdown } from '../components'
import styles from 'assets/scss/views/Auth.scss'
import defaultPropertyImage from './../assets/images/defaultPropertyImage.png'
import * as translationService from '../services/translationService'

export default () => (
  <div className={styles.Auth}>
    <div className={styles.Text}>
      <TextContainer>
        <DisplayText>{translationService.notFoundTitle()}</DisplayText>
        <Markdown source={translationService.notFoundCaption()} />
        <div className={styles.ToMyProfile}>
          <Link to="/">{translationService.verificationEmailToMyProfile()}</Link>
        </div>
      </TextContainer>
    </div>
    <div className={styles.Image}>
      <Image source={defaultPropertyImage} />
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/views/NotFoundView.js